import _ from 'lodash'
import LoadingMixin from '../mixin'

const sizeMap = {
  large: '40px',
  normal: '32px',
  small: '24px',
  mini: '16px',
}

export const spinnerProps = {
  size: {
    validator: (value) =>
      ['large', 'normal', 'small', 'mini'].indexOf(value) > -1 || (_.isNumber(value) || value > 0),
    default: 'normal',
  },
}

export default {
  name: 'KSpinner',
  mixins: [LoadingMixin],
  props: spinnerProps,
  data() {
    return {}
  },
  computed: {
    css() {
      return {
        'km-spinner': true,
        [`km-spinner--${this.type}`]: true,
        'km-spinner--colorful': this.colorful,
      }
    },
    finalSize() {
      if (typeof this.size === 'string') {
        return sizeMap[this.size] || sizeMap['normal']
      }
      return this.size + 'px'
    },
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    renderLoading() {
      return (
        <svg
          v-show={this.shouldShow}
          class={this.css}
          width={this.finalSize}
          height={this.finalSize}
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            class="km-spinner__path"
            fill="none"
            stroke-width="6"
            stroke-linecap="round"
            cx="33"
            cy="33"
            r="30"
          />
        </svg>
      )
    },
  },
}
